import type { Meta } from '@ps/web-martech-cms-types';
import type { ButtonHTMLAttributes } from 'react';
import React from 'react';

import { CMSCTA, CMSHeading, CMSLinkedImage } from '@swf/cms';

import useGeoVisibility from '../CMSContainer/hooks/useGeoVisibility';

import styles from './CMSBonus.scss';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  bonus: Meta['bonus'];
  visibility_rules: Meta['visibility_rules'];
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const CMSBonus: React.FC<Props> = ({ bonus, visibility_rules, onClick }) => {
  const [isVisible] = useGeoVisibility(visibility_rules);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.bonus}>
      <CMSLinkedImage {...bonus.linked_image} className={styles.bonusImage} animated />
      {bonus?.code ? (
        <CMSCTA
          {...bonus.button}
          data-bonus-code={bonus.code}
          title={`${bonus.button.title + ': ' || ''}\u201c${bonus.code}\u201d`}
          onClick={onClick}
        />
      ) : (
        <CMSHeading
          {...bonus.linked_image.link}
          level="h3"
          size="s"
          hero={false}
          alignment={null}
        />
      )}
    </div>
  );
};

export default CMSBonus;
